export default __webpack_public_path__ + "static/media/logo.6c1b68b1.svg";